import { orderBy } from 'lodash';
import React from 'react';
import { getDataFromResponse } from '../../../services/util';

const getFormattedRiskIndicators = (riskIndicators, riskIndicatorGraphData) => {
  let riskIndicatorFormattedData = [];
  if (riskIndicators.length > 0 && riskIndicatorGraphData.length > 0) {
    riskIndicatorGraphData.forEach((o, index) => {
      riskIndicators.map((riskIndicatorMetaData) => {
        if (
          String(o.riskIndicatorId) ===
          String(riskIndicatorMetaData.riskIndicatorId)
        ) {
          riskIndicatorFormattedData.push({
            ...o,
            ...riskIndicatorMetaData
          });
        }
      });
    });
  }
  riskIndicatorFormattedData = orderBy(
    riskIndicatorFormattedData,
    ['importance'],
    ['desc']
  );
  return { riskIndicatorFormattedData };
};

export const processDataFromProps = (props) => {
  const {
    customerProfileResponse,
    getRiskScoreHistoryResponse,
    associatedCustomersResponse,
    clusterInformationResponse,
    riskIndicatorsResponse,
    riskIndicatorsGraphResponse,
    clusterInformation,
    crsTransactionProductionMappingResponse,
    crsFeatureCategoryCodesResponse,
    crsTransactionTypesResponse,
    alertHistoryResponse,
    transactionHistoryResponse,
    crsFeatureCodesResponse,
    trendAnalysisResponse
  } = props;

  const riskIndicatorData = getDataFromResponse(
    riskIndicatorsResponse,
    'array'
  );
  const crsFeatureCategoryCodesData = getDataFromResponse(
    crsFeatureCategoryCodesResponse,
    'array'
  );
  const riskIndicatorGraphData = getDataFromResponse(
    riskIndicatorsGraphResponse,
    'array'
  );
  const { riskIndicatorFormattedData } = getFormattedRiskIndicators(
    riskIndicatorData,
    riskIndicatorGraphData
  );
  const featureCodesResponse = getDataFromResponse(
    crsFeatureCodesResponse,
    'array'
  );
  const transactionTypesResponse = getDataFromResponse(
    crsTransactionTypesResponse,
    'array'
  );
  //const trendAnalysisData = getDataFromResponse(trendAnalysisResponse,"object");
  return {
    customerProfileData: customerProfileResponse, //Finalised, Use Above if Any Processing is Required
    getRiskScoreHistoryResponse,
    associatedCustomersResponse,
    featureCodesResponse,
    transactionTypesResponse,
    clusterInformationResponse,
    clusterInformation,
    crsTransactionProductionMappingResponse,
    crsFeatureCategoryCodesData,
    crsTransactionTypesResponse,
    alertHistoryResponse,
    transactionHistoryResponse,
    trendAnalysisData: trendAnalysisResponse,
    riskIndicatorsObject: {
      riskIndicatorData,
      riskIndicatorGraphData,
      riskIndicatorFormattedData
    }
  };
};

export const TransactionHeader = {
  data: {
    credit_debit: ['CR', 'DR']
  }
};

export const NumberToMillionFormat = (num) => {
  if (num < 100000) {
    return Math.round(num * 100) / 100;
  } else {
    return (num / 1000000).toFixed(2) + 'M'; // convert to M for number from > 1 million
  }
};

const getScoreColor = (score) => {
  if (score <= 30) {
    return '#48C93D';
  } else if (score <= 60) {
    return '#EB9229';
  } else {
    return '#E84D42';
  }
};

export const parseColumnsForAssociatedCustomers = (settings) => {
  let columns = null;
  if (settings) {
    const sortedSettings = orderBy(settings, ['columnIndex'], ['asc']).filter(
      (column) => column.columnVisibility
    );
    columns = sortedSettings.map((setting) => {
      const { columnId, columnName, columnDetail } = setting;
      if (columnDetail) {
        const columnDetailItem = columnDetail[0];
        if (columnDetailItem) {
          const basic = {
            title: columnDetailItem.itemLabel,
            dataIndex: columnDetailItem.itemName,
            key: columnDetailItem.itemName
          };
          if (columnDetailItem.itemName === 'PRIMARY_PARTY_KEY')
            return { ...basic, render: (text) => <strong>{text}</strong> };
          if (columnDetailItem.itemName === 'RISK_RATING')
            return {
              ...basic,
              render: (score) => (
                <div
                  style={{
                    fontWeight: 'bold',
                    color: getScoreColor(score)
                  }}>
                  {score}
                </div>
              )
            };
          return basic;
        } else {
          return {
            title: columnName,
            dataIndex: columnId,
            key: columnId
          };
        }
      }
    });
  }
  return columns;
};
